var labels = {
  summary: {
    es: 'General',
    en: 'Overview'
  },
  data_management: {
    es: 'Métricas Módulo Gestión de Datos',
    en: 'Metrics Module Data Management'
  },
  attributes: {
    es: 'Métricas Módulo Marketplace de Atributos',
    en: 'Metrics Module Attribute Marketplace'
  },
  audiences: {
    es: 'Métricas Módulo Audiencias Digitales',
    en: 'Metrics Module Digital Audiences'
  },
  insights: {
    es: 'Métricas Módulo Conocimiento del Cliente',
    en: 'Metrics Module Insights'
  },
  mlops: {
    es: 'Métricas Módulo MLOps',
    en: 'Metrics Module MLOps'
  },
  assets_corp: {
    es: 'Gobierno de Activos',
    en: 'Asset Governance'
  },
  maturity_government: {
    es: 'Madurez de Gobierno',
    en: 'Governance Maturity'
  },
  tables_government: {
    es: 'Gobierno de Tablas',
    en: 'Table Governance'
  },
  quality_government: {
    es: 'Gobierno de Calidad',
    en: 'Quality Governance'
  },
  security_government: {
    es: 'Gobierno de Seguridad',
    en: 'Security Governance'
  },
  dashboard_government: {
    es: 'Gobierno de Reportes',
    en: 'Dashboard Governance'
  },
  des_summary: {
    es: 'Dashboard que muestra la acciones realizadas por los colaboradores del grupo dentro de la plataforma INCA.',
    en: 'Dashboard that shows the actions carried out by the collaborators within the INCA platform.'
  },
  des_data_management: {
    es: 'Dashboard que muestra la acciones realizadas por los colaboradores del grupo dentro del módulo Gestión de Datos.',
    en: 'Dashboard that shows the actions carried out by the collaborators within the Data Management Module.'
  },
  des_attributes: {
    es: 'Dashboard que muestra la acciones realizadas por los colaboradores del grupo dentro del módulo Tienda de Atributos.',
    en: 'Dashboard that shows the actions carried out by the collaborators within the Attribute Marketplace Module.'
  },
  des_audiences: {
    es: 'Dashboard que muestra la acciones realizadas por los colaboradores del grupo dentro del módulo Audiencias Digitales.',
    en: 'Dashboard that shows the actions carried out by the collaborators within the Digital Audience Module.'
  },
  des_insights: {
    es: 'Dashboard que muestra la acciones realizadas por los colaboradores del grupo dentro del módulo Conocimiento de Cliente.',
    en: 'Dashboard that shows the actions carried out by the collaborators within the Insights Module.'
  },
  des_mlops: {
    es: 'Dashboard que muestra la acciones realizadas por los colaboradores del grupo dentro del módulo MLOps.',
    en: 'Dashboard that shows the actions carried out by the collaborators within the MLOps Module.'
  },
  des_assets_corp: {
    es: 'Dashboard que muestra los activos corporativos y su gestión.',
    en: 'Dashboard that shows corporate assets and their management.'
  },
  des_tables_government: {
    es: 'Dashboard que muestra las tablas de gobierno de datos y sus métricas.',
    en: 'Dashboard that shows data governance tables and their metrics.'
  },
  des_quality_government: {
    es: 'Dashboard que muestra las métricas de calidad de gobierno de datos.',
    en: 'Dashboard that shows data governance quality metrics.'
  },
  des_security_government: {
    es: 'Dashboard que muestra las métricas de seguridad de gobierno de datos.',
    en: 'Dashboard that shows data governance security metrics.'
  },
  des_dashboard_government: {
    es: 'Dashboard general de gobierno de datos con métricas clave.',
    en: 'General data governance dashboard with key metrics.'
  },
  des_maturity_government: {
    es: 'Dashboard que muestra el nivel de madurez del gobierno de datos.',
    en: 'Dashboard that shows the data governance maturity level.'
  }
};
export default labels;